/* eslint-disable import/no-duplicates */
/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
import "react-big-calendar/lib/sass/styles.scss";
import "react-datepicker/dist/react-datepicker.css";
import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import DataTable from "react-data-table-component";
import { faCalculator, faCheck, faClock, faHeadSideVirus } from "@fortawesome/free-solid-svg-icons";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Tab, Tabs } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useLocation, withRouter } from "react-router";
import DatePicker from "react-datepicker";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import DateRangeComponent from "../../components/DateRange";
import KpiCard from "../../components/kpiCard";
import { StyledSelect } from "../../components/StyledSelect";
import ModalCalendarEvent from "./ModalCalendarEvent";
import { fetchNovedades } from "../../services/novedadesServices";
import useFetcher from "../../hooks/useFetcher";
import { novedadUtil, statusNovedad } from "../../utils/novedadUtil";
import TaskEdit from "../NovedadDetail/TaskEdit";
import modulos from "../../mocks/modulos";
// import ACTIVITIES from "../../../activities.json";
import { fetchTaskCategories } from "../../services/taskServices";
import { useAuth } from "../../context/AuthContext";
import { taskUtil } from "../../utils/taskUtil";
import { humanDateFormat, queryDateFormat } from "../../../config/constants";
import TaskListTable from "../../components/TaskList/taskListTable";
import Export from "./Export";
import { fetchActivitiesByMonth } from "../../services/activityServices";
import TaskList from "../../components/TaskList";
import AlertList from "../../components/AlertList";
import { fetchNovedad } from "../../services/novedadesServices";

moment.locale("es", {
  months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_"),
  monthsShort: "Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.".split("_"),
  weekdays: "Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado".split("_"),
  weekdaysShort: "Dom._Lun._Mar._Mier._Jue._Vier._Sab.".split("_"),
  weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_"),
});

const localizer = momentLocalizer(moment);
const actualYearStr = moment().format("YYYY");
const firstDayLastYear = `1/1/${actualYearStr - 1}`;
const monthStrList = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const locale = {
  localize: {
    month: (n) => monthStrList[n],
  },
  formatLong: {
    date: () => "dd/mm/yyyy",
  },
};

const optionsMonth = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const monthQuery = query.get("month");
  const yearQuery = query.get("year");
  const monthStrList = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  const yearList = ["2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030"];
  const monthOptions = [];
  const yearOptions = [];
  const actualMonth = Number(monthQuery) || Number(moment().format("MM"));
  const actualYear = Number(yearQuery) || Number(moment().format("YYYY"));

  for (let index = 0; index < monthStrList.length; index += 1) {
    const element = {
      label: monthStrList[index],
      value: index + 1,
    };
    monthOptions.push(element);
  }
  for (let index = 0; index < yearList.length; index += 1) {
    const element = {
      label: yearList[index],
      value: Number(yearList[index]),
    };
    yearOptions.push(element);
  }

  const actualMonthOption = monthOptions.find((m) => m.value === actualMonth);
  const actualYearOption = yearOptions.find((m) => m.value === actualYear);

  return [actualMonth, actualMonthOption, actualYear, actualYearOption];
};

const countKpis = (novedades = []) => {
  let pendientes = 0;
  let gestion = 0;
  let resuelto = 0;
  novedades.forEach((nov) => {
    const novedad = novedadUtil(nov);
    const statusStr = novedad.statusStr(true);
    pendientes += statusNovedad.PENDIENTE === statusStr ? 1 : 0;
    gestion += statusNovedad.GESTION === statusStr ? 1 : 0;
    resuelto += statusNovedad.RESUELTA === statusStr ? 1 : 0;
  });

  const total = pendientes + gestion + resuelto;

  return { total, pendientes, gestion, resuelto };
};

const optionsClient = (novedades = []) => {
  const clientesSet = new Set();
  const clientesArr = [];
  novedades.forEach((nov) => {
    const cli = nov.cliente;
    const has = clientesSet.has(cli.razonSocial);
    if (!has) {
      clientesSet.add(cli.razonSocial);
      clientesArr.push({ label: cli.razonSocial, value: cli.razonSocial });
    }
  });
  return clientesArr;
};

const tasksForCalendar = (novedades = [], categoriesTask) => {
  const types = categoriesTask.type;
  const tareas = novedades
    .reduce((allTasks, novedad) => {
      const tasks = [...novedad.tareas].map((tarea) => {
        const clienteStr = novedad.cliente.razonSocial ? `${novedad.cliente.numeroDeLegajo.replace(".0000", "")} - ${novedad.cliente.razonSocial}` : "";
        const typeTaskStr = types ? types.find((type) => type.id === tarea.type).text : "";
        return { ...tarea, title: `${clienteStr} ${typeTaskStr}` };
      });
      return [...allTasks, ...tasks];
    }, [])
    .map((tarea) => {
      const taskCalendar = {
        ...tarea,
        start: moment(tarea.dueDate).toDate(),
        end: moment(tarea.dueDate).add(1, "days").toDate(),
      };
      return taskCalendar;
    });
  return tareas;
};

const novedadesWithresponsable = (novedades = []) => {
  const novedadesList = novedades.map((novedad) => {
    const { tareas } = novedad;
    const orderedTasks = tareas.sort((a, b) => moment(a.dueDate) - moment(b.dueDate));
    const nextToCompleteIndex = orderedTasks.findIndex((task) => task.completeDate === null);
    if (tareas.length > 0 && nextToCompleteIndex !== -1) {
      const responsableObj = orderedTasks[nextToCompleteIndex].responsable;
      return { ...novedad, responsable: responsableObj };
    }
    return { ...novedad, responsable: { nombreApellido: novedad.responsable.nombreApellido } };
  });
  return novedadesList;
};

// Export excel
const convertArrayOfObjectsToCSV = (array, categoriesTask, activitiesData) => {
  let result;
  const types = categoriesTask.type;
  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  // const keys = Object.keys(data[0]);
  const keys = ["Legajo", "Cliente", "Sucursal", "Estado", "Dias Vencimiento"];

  types.forEach((type) => {
    keys.push(`Responsable ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`);
    keys.push(`Vencimiento ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`);
    keys.push(`Resolucion ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`);
    keys.push(`Estado ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`);
  });

  keys.push(`Observaciones`);
  keys.push(`Comentarios`);

  result = "";
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((i) => {
    // se filtra las tareas para eliminar del listado las alertas (class = 2)
    let item = i;
    item.tareas = item.tareas.filter((tarea) => tarea.class.id === 1);

    let ctr = 0;
    const novedadObj = novedadUtil(item);
    const nextDueDate = novedadObj.nextDueDate();
    const novedadData = {
      Legajo: item.cliente.numeroDeLegajo.replace(".0000", ""),
      Cliente: item.cliente.razonSocial,
      Sucursal: item.sucursal.titulo,
      Estado: novedadObj.statusStr(),
      "Dias Vencimiento": nextDueDate ? moment(nextDueDate).diff(moment(), "days") : "-",
    };

    types.forEach((type) => {
      const tarea = item.tareas.find((t) => t.type === type.id);
      novedadData[`Responsable ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`] = tarea ? tarea.responsable.nombreApellido : "-";
      novedadData[`Vencimiento ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`] = tarea
        ? moment(tarea.dueDate, queryDateFormat).format(humanDateFormat)
        : "-";
      novedadData[`Resolucion ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`] =
        tarea && tarea.completeDate ? moment(tarea.completeDate, queryDateFormat).format(humanDateFormat) : "-";
      novedadData[`Estado ${type.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`] = tarea ? taskUtil(tarea).statusStr() : "-";
    });

    const userActivities = Array.from(activitiesData).reduce((acc, el) => {
      if (el.ActivityRels.entityId === item.id && !el.changes) {
        acc.push(el);
      }
      return acc;
    }, []);

    let comentarios = "";

    userActivities.forEach((activity) => {
      comentarios += ` El ${activity.createdAt.slice(0, 10)} ${activity.usuario.usuario} comentó ${activity.description} |`;
    });

    novedadData.Observaciones = item.observations;
    novedadData.Comentarios = comentarios;

    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += `"${novedadData[key]}"`;

      ctr += 1;
    });
    result += lineDelimiter;
  });

  return result;
};

const downloadCSV = (array, categoriesTask, activitiesData) => {
  const link = document.createElement("a");
  const csv = convertArrayOfObjectsToCSV(array, categoriesTask, activitiesData);
  if (csv == null) return;

  const filename = `Novedades-${moment().format(humanDateFormat)}.csv`;

  link.setAttribute("href", `data:text/csv;charset=utf-8,${encodeURI(`sep=,\n${csv}`)}`);
  link.setAttribute("download", filename);
  link.click();
};

const cacheFetchNovedades = (location) => {
  if (location.state && location.state.novedades && Array.isArray(location.state.novedades.rows)) {
    return async (params) => {
      if (params.forceRefresh) {
        // eslint-disable-next-line no-param-reassign
        delete params.forceRefresh;
        return fetchNovedades(params);
      }
      return { result: location.state.novedades };
    };
  }
  return fetchNovedades;
};

const Calendars = ({ match, history, location }) => {
  // eslint-disable-next-line max-len
  const { currentUser } = useAuth();
  const itemId = match.params.id;
  const query = new URLSearchParams(location.search);
  const monthQuery = query.get("month");
  const [actualMonth, actualMonthOption, actualYear, actualYearOption] = optionsMonth();

  const [monthSelected, setMonthSelected] = useState(actualMonthOption.value - 1);
  const [yearSelected, setYearSelected] = useState(actualYearOption.value);
  const newDate = new Date();
  newDate.setFullYear(actualYear);

  newDate.setMonth(actualMonth - 1);
  const [selectedDate, setSelectedDate] = useState(newDate);
  const [categoriesTask] = useFetcher(fetchTaskCategories);
  const novedadesFilter = [{ month: monthSelected + 1, year: yearSelected }];
  const [novedades, isLoadingNovedades, errNovedades, , refreshNovedades] = useFetcher(cacheFetchNovedades(location), novedadesFilter);
  const novedadesData = novedades && novedades.rows;
  const clientesOpt = optionsClient(novedadesData);
  const [clienteSelected, setClienteSelected] = useState(location.state && location.state.clienteSelected ? location.state.clienteSelected : undefined);
  const [findQuery, setFindQuery] = useState(location.state && location.state.findQuery ? location.state.findQuery : "");
  const [filterStatus, setFilterStatus] = useState(location.state && location.state.filterStatus ? location.state.filterStatus : undefined);
  const [eventSelected, setEventSelected] = useState();
  const [isOpenModal, setIsOpenModal] = useState();
  const [dateRange, setDateRange] = useState(location.state && location.state.dateRange ? location.state.dateRange : {});
  const [novedadesFiltered, setNovedadesFiltered] = useState(novedadesData || []);
  const [kpiResults, setKpiResults] = useState(countKpis(novedadesFiltered));
  const { total: kpiTotal, pendientes: kpiPendiente, gestion: kpiGestion, resuelto: kpiResuelto } = kpiResults;
  const isAdmin = currentUser.haveAdminAccess(modulos.CALENDAR);
  const [tareasCalendar, setTareasCalendar] = useState([]);
  const [tareas, setTareas] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(location.state && location.state.currentPage);
  const [currentSortFieldId, setCurrentSortFieldId] = useState(location.state && location.state.currentSortFieldId);
  const [currentSortAsc, setCurrentSortAsc] = useState(location.state && location.state.currentSortAsc);
  const minRangeDate = moment({ month: monthSelected, year: actualYearStr }).startOf("month");
  const maxRangeDate = moment({ month: monthSelected, year: actualYearStr }).endOf("month");
  const [activitiesMonth, isLoadingActivitiesMonth] = useFetcher(fetchActivitiesByMonth, [{ entity: "novedad", params: novedadesFilter }]);
  const actions = novedadesData && <Export onExport={() => downloadCSV(novedadesFiltered, categoriesTask, activitiesMonth)} />;
  const [calendarDate, setCalendarDate] = useState(minRangeDate.toDate());
  const [selectedTabKey, setSelectedTabKey] = useState("table");
  const doNovedadesFilter = () => {
    if (!Array.isArray(novedadesData)) {
      setNovedadesFiltered([]);
      return;
    }
    const filterValueNormalize = findQuery;
    const { startDate, endDate } = dateRange;
    const hasta = endDate && moment(endDate).add(23, "hour").toDate();
    const desde = startDate && moment(startDate).toDate();

    const likeFindQuery = (nov) =>
      nov.cliente.razonSocial.toLowerCase().includes(filterValueNormalize) ||
      nov.cliente.numeroDeLegajo.replace(".0000", "").includes(filterValueNormalize) ||
      nov.sucursal.titulo.toLowerCase().includes(filterValueNormalize) ||
      nov.responsable.nombreApellido.toLowerCase().includes(filterValueNormalize);

    const filteredWithStatus = novedadesWithresponsable(novedadesData).filter(
      (nov) =>
        (!clienteSelected || nov.cliente.razonSocial === clienteSelected.value) &&
        (!desde || novedadUtil(nov).endDate() >= desde) &&
        (!hasta || novedadUtil(nov).startDate() <= hasta) &&
        likeFindQuery(nov)
    );

    setKpiResults(countKpis(filteredWithStatus));

    const filtered = filteredWithStatus.filter((nov) => !filterStatus || novedadUtil(nov).statusStr(true) === filterStatus);

    setNovedadesFiltered(filtered);
    window.filtered = filtered;

    let tareasCalc = [];
    if (filtered && filtered.length === 1) {
      tareasCalc = filtered[0].tareas;
    } else if (filtered && filtered.length > 0) {
      tareasCalc = filtered.reduce((allTasks, novedad) => [...(Array.isArray(allTasks) ? allTasks : allTasks.tareas), ...novedad.tareas]);
    }
    tareasCalc = tareasCalc.filter((tarea) => (!desde || taskUtil(tarea).dueDate() >= desde) && (!hasta || taskUtil(tarea).dueDate() <= hasta));
    setTareas(tareasCalc);

    const tareasForCalendar = tasksForCalendar(filtered, categoriesTask);
    setTareasCalendar(tareasForCalendar);
  };

  useEffect(() => {
    if (novedadesFiltered) {
      const tasks = [];
      const alerts = [];
      for (const nov of novedadesFiltered) {
        for (const tarea of nov.tareas) {
          if (tarea.class.id === 1) {
            tasks.push(tarea);
          }
          if (tarea.class.id === 2) {
            alerts.push(tarea);
          }
        }
      }
      setTasks(tasks);
      setAlerts(alerts);
    }
  }, [novedadesFiltered]);

  useEffect(() => {
    const { startDate } = dateRange;
    const desde = startDate && moment(startDate);

    if (desde && desde.format("M") !== minRangeDate.format("M")) {
      setDateRange({});
    }
  }, [JSON.stringify({ monthSelected })]);

  useEffect(() => {
    doNovedadesFilter();
  }, [JSON.stringify({ clienteSelected, filterStatus, findQuery, dateRange, isLoadingNovedades })]);

  const handleDatesChange = (event) => {
    setDateRange(event.rangeDates);
  };

  const handleClientChange = (event) => {
    if (event) {
      const cliente = clientesOpt.find((cli) => cli.value === event.value);
      setClienteSelected(cliente);
    } else {
      setClienteSelected(null);
    }
  };

  const handleFindByTextQueryChange = ({ target }) => {
    setFindQuery(target.value);
  };

  const handleFilterStatus = (status) => {
    setFilterStatus(status);
  };

  const handleMonthChange = (selected) => {
    const momentDate = moment(new Date(selected));
    const month = momentDate.month();
    const year = momentDate.year();

    setMonthSelected(month);
    setYearSelected(year);
    const newDate = new Date();
    setSelectedDate(newDate.setMonth(month));
    setSelectedDate(newDate.setFullYear(year));
    const fecha = {
      month,
      year,
    };
    const date = moment({ month: selected.getMonth(), year: selected.getFullYear() }).startOf("month").toDate();
    // refreshNovedades([{ ...fecha, forceRefresh: true }]);
    history.push({ search: `month=${month + 1}&year=${year}` });
    setCurrentPage(1);
    setCalendarDate(date);
  };

  const handleNovedadClicked = (row) => {
    const backLocation = { ...location };
    backLocation.search = `month=${monthSelected}`;
    backLocation.state = backLocation.state ? backLocation.state : {};
    backLocation.state.novedades = novedades;
    backLocation.state.findQuery = findQuery;
    backLocation.state.filterStatus = filterStatus;
    backLocation.state.dateRange = dateRange;
    backLocation.state.currentPage = currentPage;
    backLocation.state.currentSortAsc = currentSortAsc;
    backLocation.state.currentSortFieldId = currentSortFieldId;
    backLocation.state.clienteSelected = clienteSelected;
    history.push({
      pathname: `/novedad/${row.id}/detail`,
      state: {
        novedad: row,
        from: backLocation,
      },
    });
  };

  const handleTabsChange = (key) => {
    setSelectedTabKey(key);
  };

  const handleToggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleRefreshData = () => {
    // handleRefresh--------------------------------------------------------------------------------------------------
    refreshNovedades([{ ...novedadesFilter[0], forceRefresh: true }]);
  };

  const eventClick = (e) => {
    const eventData = tareas.find((el) => el.id === e.id);
    setEventSelected(eventData);
    handleToggleModal();
  };

  const newTaskUpdated = (updatedTask) => {
    const updatedTaskCalendar = {
      ...updatedTask,
      start: moment(updatedTask.dueDate).toDate(),
      end: moment(updatedTask.dueDate).add(1, "days").toDate(),
    };
    const newTasks = [...tareasCalendar];
    const indexUpdated = newTasks.findIndex((item) => item.id === updatedTask.id);
    newTasks[indexUpdated] = updatedTaskCalendar;
    setTareas(newTasks);
    // doNovedadesFilter();
    setIsOpenModal(false);
  };

  const activityComponent = useRef();

  const handleChangeRefreshActivity = () => {
    activityComponent.current.refreshActivities();
  };

  const onTasksChange = () => {
    handleChangeRefreshActivity();
  };

  // const onAlertsChange = () => {
  //   handleChangeRefreshActivity();
  // };

  const getNovedad = (tarea) => {
    return novedadesFiltered && novedadesFiltered.find((novedad) => novedad.id === tarea.novedadId);
  };
  let modalData = [];
  if (eventSelected) {
    const taskfilter = tareas.filter((task) => {
      return getNovedad(task).cliente.razonSocial === getNovedad(eventSelected).cliente.razonSocial && task.title === eventSelected.title;
    });
    modalData.push(taskfilter);
  }
  return (
    <>
      <Helmet>
        <title>PIN - Sistema de Recordatorios</title>
      </Helmet>
      <Breadcrumb title="Calendario" parent="Sistema de Recordatorios" onRefreshClick={handleRefreshData} />
      {eventSelected && (
        <ModalCalendarEvent modalTitle="Detalle Tarea" handleIsOpenModal={isOpenModal} handleToggleModal={handleToggleModal}>
          <TaskEdit taskSelected={eventSelected} newTaskUpdated={newTaskUpdated} isAdmin={isAdmin} isLider={currentUser.user.Pi.itemId === eventSelected.liderId} />
        </ModalCalendarEvent>
      )}
      {/* cambie el segundo argumento de isLoading de isLoadingActivitiesMonth a isLoadingNovedades
      para mostrar el spiner al apretar el boton refresh */}
      <BlurSpinner isLoading={(isLoadingNovedades, isLoadingNovedades)}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3 col-12">
                      <div className="form-group">
                        <label htmlFor="query" className="col-form-label pt-0 w-100">
                          Busqueda por texto
                          <input
                            className="form-control"
                            type="search"
                            placeholder="Buscar.."
                            onChange={handleFindByTextQueryChange}
                            name="query"
                            id="query"
                            value={findQuery}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="cliente" className="col-form-label pt-0 w-100">
                          Cliente
                          <StyledSelect
                            id="cliente"
                            name="cliente"
                            isClearable
                            placeholder="Todos"
                            options={clientesOpt}
                            value={clienteSelected}
                            onChange={handleClientChange}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="mes" className="col-form-label pt-0 w-100">
                          Mes y Año
                          <DatePicker
                            className="form-control digits"
                            locale={locale}
                            showMonthYearPicker
                            showFullMonthYearPicker
                            dateFormat="MMMM yyyy"
                            selected={selectedDate}
                            onChange={handleMonthChange}
                            minDate={new Date(firstDayLastYear)}
                            maxDate={moment().toDate()}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <DateRangeComponent
                          onChange={handleDatesChange}
                          values={dateRange}
                          label="Rango de fechas"
                          minDate={minRangeDate.toDate()}
                          maxDate={maxRangeDate.toDate()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "00B398",
                          id: null,
                          status: "active",
                          text: "Total",
                        }}
                        icon={faCalculator}
                        value={{
                          count: kpiTotal,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={!filterStatus}
                      />
                    </div>
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "f2a900",
                          id: statusNovedad.PENDIENTE,
                          status: "active",
                          text: "Pendiente",
                        }}
                        icon={faClock}
                        value={{
                          count: kpiPendiente,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={filterStatus === statusNovedad.PENDIENTE}
                      />
                    </div>
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "17a2b8",
                          id: statusNovedad.GESTION,
                          status: "active",
                          text: "En gestión",
                        }}
                        icon={faHeadSideVirus}
                        value={{
                          count: kpiGestion,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={filterStatus === statusNovedad.GESTION}
                      />
                    </div>
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "43b02a",
                          id: statusNovedad.RESUELTA,
                          status: "active",
                          text: "Resuelto",
                        }}
                        icon={faCheck}
                        value={{
                          count: kpiResuelto,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={filterStatus === statusNovedad.RESUELTA}
                      />
                    </div>
                  </div>
                  <Tabs activeKey={selectedTabKey} onSelect={handleTabsChange}>
                    <Tab eventKey="table" title="Grilla">
                      <div className="table-responsive support-table">
                        {isLoadingNovedades || errNovedades ? (
                          <></>
                        ) : (
                          <DataTable
                            title="Novedades"
                            paginationComponentOptions={{ rowsPerPageText: "Novedades por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todos" }}
                            paginationDefaultPage={currentPage}
                            onChangePage={(page) => setCurrentPage(page)}
                            defaultSortFieldId={currentSortFieldId}
                            defaultSortAsc={currentSortAsc === "asc"}
                            onSort={(column, direction) => {
                              setCurrentSortFieldId(column.id);
                              setCurrentSortAsc(direction);
                            }}
                            noDataComponent={
                              <div className="p-3">
                                <b>No se encontraron novedades</b>
                              </div>
                            }
                            striped
                            pagination
                            onRowClicked={handleNovedadClicked}
                            data={novedadesFiltered}
                            actions={actions}
                            columns={[
                              {
                                name: "Subcliente",
                                // eslint-disable-next-line radix
                                selector: (row) => row.cliente.numeroDeLegajo.replace(".0000", "").padStart(7, 0),
                                sortable: true,
                                center: true,
                                id: "subcliente",
                                style: {
                                  cursor: "pointer",
                                  textAlign: "center",
                                },
                              },
                              {
                                name: "Cliente",
                                selector: (row) => row.cliente.razonSocial,
                                sortable: true,
                                center: true,
                                wrap: true,
                                id: "cliente",
                                style: {
                                  cursor: "pointer",
                                  textAlign: "center",
                                },
                              },
                              {
                                name: "Responsable",
                                selector: (row) => row.responsable.nombreApellido,
                                sortable: true,
                                center: true,
                                wrap: true,
                                id: "responsable",
                                style: {
                                  cursor: "pointer",
                                  textAlign: "center",
                                },
                              },
                              {
                                name: "Sucursal",
                                selector: (row) => row.sucursal.titulo,
                                sortable: true,
                                center: true,
                                wrap: true,
                                id: "sucursal",
                                style: {
                                  cursor: "pointer",
                                  textAlign: "center",
                                },
                              },
                              {
                                name: "Desde",
                                selector: (row) => novedadUtil(row).startDateFormatted(),
                                sortable: true,
                                center: true,
                                wrap: true,
                                id: "desde",
                                style: {
                                  cursor: "pointer",
                                  textAlign: "center",
                                },
                              },
                              {
                                name: "Hasta",
                                selector: (row) => novedadUtil(row).endDateFormatted(),
                                sortable: true,
                                center: true,
                                wrap: true,
                                id: "hasta",
                                style: {
                                  cursor: "pointer",
                                  textAlign: "center",
                                },
                              },
                              {
                                name: "Estado",
                                selector: (row) => {
                                  const objNovedad = novedadUtil(row);
                                  const status = objNovedad.statusStr();
                                  const colorClass = objNovedad.statusColorClass(status);
                                  return (
                                    <div className="text-center">
                                      <span
                                        className={`badge ${colorClass}`}
                                        style={{
                                          fontSize: "unset",
                                        }}
                                      >
                                        {status}
                                      </span>
                                    </div>
                                  );
                                },
                                center: true,
                                id: "closeLoop",
                                wrap: true,
                                style: {
                                  cursor: "pointer",
                                  textAlign: "center",
                                },
                              },
                            ]}
                          />
                        )}
                      </div>
                    </Tab>
                    <Tab eventKey="tasks" title="Tareas">
                      <TaskList tasks={tasks} novedades={novedadesData} setTasks={setTasks} onChange={onTasksChange} withPaging withClientData />
                    </Tab>
                    <Tab eventKey="alerts" title="Alertas">
                      <div>
                        {isLoadingNovedades || errNovedades ? (
                          <></>
                        ) : (
                          <AlertList alerts={alerts} setAlerts={setAlerts} novedades={novedadesData} withPaging withClientData />
                        )}
                      </div>
                    </Tab>

                    <Tab eventKey="calendar" title="Calendario">
                      <div className="pt-4">
                        <Calendar
                          localizer={localizer}
                          scrollToTime={minRangeDate.toDate()}
                          defaultDate={minRangeDate.toDate()}
                          date={calendarDate}
                          onNavigate={(date) => {
                            setCalendarDate(date);
                          }}
                          onSelectEvent={eventClick}
                          views={["month"]}
                          events={tareasCalendar}
                          eventOverlap
                          dragRevertDuration={500}
                          dragScroll
                          showMultiDayTimes
                          step={60}
                          startAccessor="start"
                          endAccessor="end"
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(Calendars);
